import styled from 'styled-components';
import { Colors } from 'assets/colors';
import { WL_CONFIG } from 'constants';

export const StyledActivityWrapper = styled.div`
  padding: 24px 0;

  .activity-actions {
    margin-bottom: 24px;
  }

  .activity-layout {
    display: grid;
    grid-template-columns: 320px 1fr;
    gap: 24px;
    @media (max-width: 991px) {
      grid-template-columns: 1fr;
    }
  }

  .activity-snapshot {
    min-width: 0;
  }

  .snapshot-card .ant-card-body {
    padding: 16px;
  }

  .snapshot-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;
  }

  .snapshot-info {
    flex: 1;
    min-width: 0;
  }

  .snapshot-name {
    font-weight: 700;
    font-size: 16px;
    color: ${Colors.textPrimary1};
  }

  .snapshot-meta {
    font-size: 13px;
    color: #717679;
  }

  .snapshot-meta a {
    color: inherit;
  }

  .snapshot-meta .muted {
    color: #999;
  }

  .snapshot-details {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 16px;
    font-size: 13px;
  }

  .snapshot-row {
    display: flex;
    align-items: center;
    gap: 8px;
    color: ${Colors.textPrimary1};
  }

  .snapshot-icon {
    color: #717679;
    width: 16px;
  }

  .snapshot-row .truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .snapshot-stats {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
    padding: 12px 0;
    border-top: 1px solid #f0f0f0;
    border-bottom: 1px solid #f0f0f0;
    margin-bottom: 12px;
  }

  .stat {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }

  .stat-label {
    font-size: 11px;
    color: #717679;
    text-transform: uppercase;
  }

  .stat-value {
    font-size: 14px;
    font-weight: 600;
    color: ${Colors.textPrimary1};
  }

  .snapshot-footer {
    font-size: 12px;
    color: #717679;
  }

  .timeline-card .ant-card-body {
    padding: 24px;
  }

  .activity-timeline .ant-timeline-item-head {
    width: 36px;
    height: 36px;
  }

  .activity-timeline-dot {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border: 2px solid;
    border-radius: 50%;
    background: #fff;
  }

  .activity-item {
    padding: 12px 16px;
    margin-left: 8px;
    margin-bottom: 8px;
    border-left: 3px solid #e8e8e8;
    border-radius: 4px;
    background: #fafafa;
  }

  .activity-item-header {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 12px;
    margin-bottom: 4px;
  }

  .activity-item-time {
    font-size: 12px;
    flex-shrink: 0;
  }

  .activity-item-body {
    font-size: 14px;
    color: #555;
    margin-bottom: 4px;
  }

  .activity-item-body a {
    color: inherit;
  }

  .activity-show-more {
    background: none;
    border: none;
    color: #1890ff;
    cursor: pointer;
    font-size: 13px;
    padding: 0;
  }

  .activity-item-link {
    margin-top: 8px;
  }

  .activity-item-link a {
    font-size: 13px;
    color: #1890ff;
  }

  .activity-load-more-footer {
    text-align: center;
    padding: 16px 0 8px;
  }

  .activity-load-more-btn {
    background: none;
    border: none;
    color: ${WL_CONFIG.colors.primary};
    cursor: pointer;
    font-size: 14px;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .activity-load-more-btn:hover:not(:disabled) {
    text-decoration: underline;
  }

  .activity-load-more-btn:disabled {
    cursor: not-allowed;
    opacity: 0.7;
  }

  .activity-end-message {
    text-align: center;
    padding: 16px 0 8px;
    font-size: 14px;
    color: #8c8c8c;
  }
`;
